import * as React from 'react';

const WalletCard24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M19 2.25C20.5188 2.25 21.75 3.48122 21.75 5V19C21.7498 20.5186 20.5187 21.75 19 21.75H5C3.48145 21.7499 2.2502 20.5185 2.25 19V5C2.25 3.4813 3.48133 2.25013 5 2.25H19ZM3.75 19C3.7502 19.6901 4.30988 20.2499 5 20.25H19C19.6902 20.25 20.2498 19.6902 20.25 19V11.75H18.0996C17.5287 11.7502 16.9122 12.0487 16.5303 12.4307C16.5128 12.4481 16.4937 12.4648 16.4746 12.4805L15.3906 13.3672C13.5109 15.2071 10.5966 15.2094 8.71484 13.373L7.625 12.4805C7.5882 12.4504 7.55389 12.4164 7.52344 12.3799C7.1966 11.9879 6.63013 11.75 6 11.75H3.75V19ZM5 7.75C4.66857 7.75006 4.35057 7.88185 4.11621 8.11621C3.88198 8.3506 3.75 8.66862 3.75 9V10.25H6C6.94189 10.25 7.94259 10.5926 8.61621 11.3525L9.6748 12.2197L9.73047 12.2695C11.0375 13.5765 13.063 13.5763 14.3701 12.2695L14.4248 12.2197L15.5068 11.334C16.1264 10.7329 17.0911 10.2502 18.0996 10.25H20.25V9C20.25 8.66851 20.1182 8.35063 19.8838 8.11621C19.6494 7.88179 19.3315 7.75 19 7.75H5ZM5 3.75C4.30975 3.75013 3.75 4.30972 3.75 5V6.55273C4.13375 6.35657 4.56096 6.25004 5 6.25H19C19.439 6.25 19.8663 6.35666 20.25 6.55273V5C20.25 4.30964 19.6904 3.75 19 3.75H5Z'
				fill='black'
			/>
		</svg>
	);
};

export default WalletCard24;
